import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import classNames from "classnames";
import {fetchApplication, setApplication} from "./app.slice";
import JsonScreen from "../Components/JsonScreen";
import Header from "../Components/Header/Header";
import SideBar from "../Components/SideBarNew";
import {makeStyles} from "@material-ui/core";
import {uid} from "react-uid";
import {Loading} from "../Utils/Loading/Loading";
import {useActions} from "./doActions";
import IntervalTimer from "../Components/JsonScreen/Screen/OtherComponents/IntervalTimer";
import ContextMenu from "../Components/JsonScreen/Screen/ScreenComponents/ContextMenu";
import {clearGlobalValues} from "../Components/JsonScreen/jsonScreen.slice";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import WebSocket from "../Components/JsonScreen/Screen/OtherComponents/WebSocket";
import ShortcutListener from "../Components/JsonScreen/Screen/OtherComponents/ShortcutListener";

const useStyles = makeStyles(theme => ({
    layout: {
        overflowY: 'hidden',
        height: 'inherit'
    },
    mainContainer: {
        height: '100%', //'calc(100% - 48px)',
        position: 'relative',
        overflowY: 'auto',
        padding: 0,
        margin: '0 auto',
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        [theme.breakpoints.up("sm")]: {
            height: '100%', //'calc(100% - 48px)',
            overflowY: 'auto',
            padding: 0,
            margin: '0 auto',
            transition: theme.transitions.create(["margin", "width"], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen
            })
        }

    },
    mainContainerShift: {
        height: '100%', //'calc(100% - 48px)',
        position: 'relative',
        overflowY: 'auto',
        padding: 0,
        margin: '0 auto',
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        [theme.breakpoints.up("sm")]: {
            padding: 0,
            transition: theme.transitions.create(["margin", "marginLeft", "width"], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen
            })
        }

    }
}));

const AppWrapper = (props) => {
    const {match: {params: {app}}} = props;
    const headerRef = useRef();

    //redux state
    const appLanding = useSelector(state => state.app.appLanding);
    const isOpenDrawer = useSelector(state => state.app.isOpenDrawer);
    const drawerWidth = useSelector(state => state.app.drawerWidth);
    const isReadyApp = useSelector(state => state.app.isReadyApp);
    const drawerProps = useSelector(state => state.app.drawerProps);

    const isMobile = useMediaQuery('(max-width:700px)');
    const [footerSource, setFooterSource] = useState(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const dispatch = useDispatch();
    const classes = useStyles();
    const {doActions, onChangeFields, cameraRef} = useActions();

    useEffect(() => {
        async function initApp() {
            dispatch(clearGlobalValues({screenId: appLanding.id}))
            setFooterSource(null)
            const appResponse = await dispatch(fetchApplication(app))

            //init onload actions
            if (appResponse.payload && appResponse.payload.landingRes) {
                const appLanding = appResponse.payload.landingRes;

                //find for application onload events
                if (appLanding.events && appLanding.events.length) {
                    if (appLanding.events[0].event === 'onOpen') {
                        await doActions(appLanding.events[0].actions, {}, null, appLanding.id, appLanding.script)
                    }
                }

                //find the footer
                let footerIndex = appLanding.children.findIndex(ch => ch.type === 'footer');
                setFooterSource(footerIndex !== -1 ? appLanding.children[footerIndex] : null)
            }

            await dispatch(setApplication(app))
        }

        initApp();
    }, [app])

    useEffect(() => {
        setHeaderHeight(headerRef.current ? headerRef.current.getBoundingClientRect().height : 0)
    }, [headerRef.current])

    if (!isReadyApp) return <Loading/>

    if (!appLanding.id) return (
        <main
            key={'mainContainer'}
            id={'mainContainer'}
            style={{
                marginLeft: isOpenDrawer ? isMobile ? 0 : drawerWidth : 0,
                height: `calc(100% - ${headerHeight}px)`
            }}
            className={classNames(classes.mainContainer, {[classes.mainContainerShift]: isOpenDrawer})}
        >
            <JsonScreen
                {...props}
                doActions={doActions}
                onChangeFields={onChangeFields}
                footerSource={footerSource}
                cameraRef={cameraRef}
            />
        </main>
    )
    return (
        <>
            {appLanding.otherComponents ? (
                appLanding.otherComponents.map(component => {
                    if (component.type === 'webSocket') {
                        return <WebSocket key={uid(component)}
                                          doActions={doActions}
                        />
                    }
                    if (component.type === 'interval') {
                        return (
                            <IntervalTimer
                                key={uid(component)}
                                doActions={(action, context, event) => doActions(action, context, event, appLanding.id)}
                                component={component}
                            />
                        )
                    }
                    if (component.type === 'shortcut') {
                        return (
                            <ShortcutListener
                                key={uid(component)}
                                component={component}
                                doActions={doActions}
                                target={window}
                            />
                        )
                    }
                    if (component.type === 'context') {
                        return <ContextMenu
                            doActions={doActions}
                            component={component}
                            screenName={appLanding.id}
                        />
                    }
                    return null
                })
            ) : (<></>)}
            {appLanding.children.map(item => {
                const {styles: sourceStyles} = item;
                const styles = sourceStyles ? sourceStyles[0] : {};

                if (!Object.keys(item).length) return

                if (item.type === 'header') {
                    return <Header
                        headerRef={headerRef}
                        key={uid(item)}
                        component={item}
                        doActions={doActions}
                        screenName={appLanding.id}
                        onChangeFields={onChangeFields}
                    />
                }
                if (item.type === 'sidebar') {
                    return <SideBar
                        key={uid(item)}
                        component={item}
                        doActions={doActions}
                        screenName={appLanding.id}
                        onChangeFields={onChangeFields}
                    />
                }
                if (item.type === 'footer') {
                    return <div key={uid(item)}/>
                }
                if (item.type === 'frame') {
                    return (
                        <main
                            key={uid(item)}
                            id={'mainContainer'}
                            style={{
                                marginLeft: isOpenDrawer ? isMobile ? 0 : drawerWidth : drawerProps.closedCompact ? 100 : 0,
                                padding: styles.padding,
                                background: styles.background,
                                height: `calc(100% - ${headerHeight}px)`
                            }}
                            className={classNames(classes.mainContainer, {[classes.mainContainerShift]: isOpenDrawer}, styles.className)}
                        >
                            <JsonScreen
                                {...props}
                                doActions={doActions}
                                onChangeFields={onChangeFields}
                                footerSource={footerSource}
                                cameraRef={cameraRef}
                            />
                        </main>
                    )
                }
                return <>undefined component</>
            })}
            {/*<ContextMenu*/}
            {/*    doActions={doActions}*/}
            {/*    //think what about screenName here, probably, when onOpenContext -> set and screeName inside describe object of context menu*/}
            {/*/>*/}
        </>
    )
}

export default AppWrapper;
